import {
  IDENTITY_VERIFICATION_DIALOG_CLOSE,
  IDENTITY_VERIFICATION_DIALOG_OPEN,
  IDENTITY_VERIFICATION_IN_PROGRESS,
  IdentityVerificationVariant,
} from 'store/actions/identityVerificationActions';

type IdentityVerificationState = {
  open: boolean;
  dismissedKey?: string;
  onNotNowCallback?: () => void;
  onCloseCallback?: () => void;
  forceOpen?: boolean;
  verificationInProgress: boolean;
  variant?: IdentityVerificationVariant;
};

const INITIAL_STATE: IdentityVerificationState = {
  open: false,
  dismissedKey: undefined,
  onNotNowCallback: undefined,
  onCloseCallback: undefined,
  forceOpen: false,
  verificationInProgress: false,
  variant: 'required',
};

const identityVerificationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case IDENTITY_VERIFICATION_DIALOG_OPEN:
      return {
        ...state,
        open: true,
        dismissedKey: undefined,
        onNotNowCallback: payload?.onNotNow,
        onCloseCallback: payload?.onClose,
        forceOpen: payload?.forceOpen || false,
        variant: payload?.variant || 'required',
      };

    case IDENTITY_VERIFICATION_DIALOG_CLOSE:
      return {
        ...state,
        open: false,
        dismissedKey: payload?.dismissedKey,
        onNotNowCallback: undefined,
        onCloseCallback: undefined,
        forceOpen: false,
        variant: 'required',
      };

    case IDENTITY_VERIFICATION_IN_PROGRESS:
      return {
        ...state,
        verificationInProgress: Boolean(payload?.inProgress),
      };

    default:
      return state;
  }
};

export default identityVerificationReducer;
